import * as React from 'react';
import type { SVGProps } from 'react';
const SvgIconFileBig = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={26} height={27} fill="none" {...props}>
    <path fill="#B2B2B2" d="M11.375.5H3.25v26h19.5V11.875H11.375z" />
    <path fill="#B2B2B2" d="M14.625.5v8.125h8.125z" />
  </svg>
);
export default SvgIconFileBig;
